// extracted by mini-css-extract-plugin
module.exports = {"title":"eRegOjQIxi7OB5IiXmYiV","changeSubscriptionButton":"_1WlOSZH_X4jComkj4Qa8WX"};